@if (account()) {
  @if (expanded()) {
    <span class="tw-flex tw-w-full tw-justify-start tw-overflow-hidden tw-gap-2 tw-pl-1">
      <button
        type="button"
        [bitMenuTriggerFor]="accountMenu"
        menuPosition="above-start"
        class="tw-py-3"
      >
        <dynamic-avatar [id]="account().id" [text]="account() | userName"></dynamic-avatar>
      </button>
      <span class="tw-flex tw-justify-center tw-flex-col tw-overflow-hidden">
        <span class="tw-truncate">{{ account() | userName }}</span>
        <small class="tw-truncate tw-text-fg-body-subtle">{{ account().email }}</small>
      </span>
    </span>
  }

  @if (!expanded()) {
    <span class="tw-flex tw-w-full tw-justify-center tw-overflow-hidden tw-gap-2">
      <button
        type="button"
        [bitMenuTriggerFor]="accountMenu"
        menuPosition="above-start"
        class="tw-py-3"
      >
        <dynamic-avatar [id]="account().id" [text]="account() | userName"></dynamic-avatar>
      </button>
    </span>
  }

  <bit-menu #accountMenu>
    <div class="tw-flex tw-min-w-52 tw-max-w-72 tw-flex-col">
      <div
        class="tw-flex tw-items-center tw-px-4 tw-py-1 tw-leading-tight tw-text-muted"
        appStopProp
      >
        <dynamic-avatar [id]="account().id" [text]="account() | userName"></dynamic-avatar>
        <div class="tw-ml-2 tw-block tw-overflow-hidden tw-whitespace-nowrap">
          <span>{{ "loggedInAs" | i18n }}</span>
          <small class="tw-block tw-overflow-hidden tw-whitespace-nowrap">
            {{ account() | userName }}
          </small>
        </div>
      </div>

      @if (selfHosted) {
        <bit-menu-divider></bit-menu-divider>
        <span class="tw-break-all tw-px-4 tw-py-1 tw-text-left tw-text-muted">
          {{ hostname }}
        </span>
      }

      <bit-menu-divider></bit-menu-divider>

      <a bitMenuItem routerLink="/settings/account">
        <bit-icon name="bwi-user" class="bwi-fw" aria-hidden="true"></bit-icon>
        {{ "accountSettings" | i18n }}
      </a>
      <a bitMenuItem href="https://github.com/timshel/oidcwarden" target="_blank" rel="noreferrer">
        <bit-icon name="bwi-question-circle" class="bwi-fw" aria-hidden="true"></bit-icon>
        {{ "getHelp" | i18n }}
      </a>
      <a bitMenuItem href="https://bitwarden.com/download/" target="_blank" rel="noreferrer">
        <bit-icon name="bwi-download" class="bwi-fw" aria-hidden="true"></bit-icon>
        {{ "getApps" | i18n }}
      </a>

      <bit-menu-divider></bit-menu-divider>

      @if (canLock$ | async) {
        <button bitMenuItem type="button" (click)="lock()">
          <bit-icon name="bwi-lock" class="bwi-fw" aria-hidden="true"></bit-icon>
          {{ "lockNow" | i18n }}
        </button>
      }

      <button bitMenuItem type="button" (click)="logout()">
        <bit-icon name="bwi-sign-out" class="bwi-fw" aria-hidden="true"></bit-icon>
        {{ "logOut" | i18n }}
      </button>
    </div>
  </bit-menu>
}
